import { Workflow, Bot, Plug, BookOpen } from "lucide-react";

const CONNECTORS = [
  { icon: BookOpen, title: "Notebook API", desc: "Generate a key and call the twin from any notebook or script to spec and scaffold services programmatically.", ep: "/api/v1/notebook" },
  { icon: Workflow, title: "AI Workflow API", desc: "Chain generation steps into repeatable backend pipelines — spec → code → migration → manifest.", ep: "/api/v1/workflow" },
  { icon: Bot, title: "AI Automation", desc: "Trigger automated backend generation and optimization on events, hooked straight into your CI.", ep: "/api/v1/automation" },
];

export const AIWorkflow = () => (
  <section id="ai-workflow" className="py-24 px-4 sm:px-6 lg:px-8 bg-background">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl mb-14">
        <span className="text-xs font-mono uppercase tracking-widest text-emerald-400">AI Workflow & AI Automation</span>
        <h2 className="mt-3 font-display text-3xl lg:text-4xl font-bold tracking-tight text-slate-100">
          Auto-connect the twin to everything you build
        </h2>
        <p className="mt-4 text-slate-400 leading-relaxed">
          Generate real, callable API keys in one click. Each connector exposes a live endpoint you can ping and drive from your own tools — no manual wiring.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {CONNECTORS.map((c, i) => (
          <div key={c.title} data-testid={`connector-card-${i}`}
            className="group glass rounded-xl border border-slate-800 p-6 hover:border-emerald-500/50 transition-colors duration-300 shadow-xl shadow-black/30">
            <div className="flex items-center justify-between mb-5">
              <div className="w-11 h-11 rounded-lg bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center">
                <c.icon className="w-5 h-5 text-emerald-400" />
              </div>
              <Plug className="w-4 h-4 text-slate-600 group-hover:text-emerald-400 transition-colors" />
            </div>
            <h3 className="font-display text-lg font-semibold text-slate-100">{c.title}</h3>
            <p className="mt-2.5 text-sm text-slate-400 leading-relaxed">{c.desc}</p>
            <code className="mt-4 block text-[11px] font-mono text-emerald-400/80 bg-slate-950 rounded-md px-3 py-2 border border-slate-800">{c.ep}</code>
          </div>
        ))}
      </div>
      <p className="mt-8 text-sm text-slate-500 font-mono">→ Generate & manage these connectors inside your Workspace.</p>
    </div>
  </section>
);
